var Lookups = EY.Consultation.Lookups;

module.exports.run = function (options) {
    var record = options.record;

    record.set({
        statusTypeId: Lookups.StatusType.Draft
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionDraft.js